export enum ProgressStatus {
  "INITIAL",
  "ONGOING",
  "COMPLETE",
}
